import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ClipboardList, X } from 'lucide-react';
import api from '@/lib/api';

const DISMISS_KEY = 'uclean_profile_reminder_dismissed';

export const ProfileReminder = () => {
  const location = useLocation();
  const [incomplete, setIncomplete] = useState(false);
  const [dismissed, setDismissed] = useState(() => sessionStorage.getItem(DISMISS_KEY) === '1');

  useEffect(() => {
    api.get('/user/profile-status')
      .then((res) => setIncomplete(!res.data?.profile_completed))
      .catch(() => setIncomplete(false));
  }, [location.pathname]);

  if (!incomplete || dismissed || location.pathname.startsWith('/quiz') || location.pathname.startsWith('/aria')) return null;

  const dismiss = () => {
    sessionStorage.setItem(DISMISS_KEY, '1');
    setDismissed(true);
  };

  return (
    <div role="status" aria-live="polite" data-testid="profile-reminder"
      className="px-4 lg:px-6 py-3 bg-purple-900/80 backdrop-blur-xl border-b border-purple-500/30 flex items-center gap-3">
      <ClipboardList className="h-5 w-5 text-green-400 shrink-0" aria-hidden="true" />
      <p className="text-sm text-white flex-1">
        <span className="font-semibold">Preencha seu cadastro (opcional)</span>
        <span className="hidden sm:inline text-purple-200"> — responda o quiz rápido para personalizarmos sua jornada.</span>
      </p>
      <Link to="/quiz/recuperacao" data-testid="profile-reminder-cta"
        className="px-4 min-h-[40px] flex items-center text-sm font-semibold rounded-lg bg-green-600 hover:bg-green-500 text-white transition-colors">
        Preencher
      </Link>
      <button type="button" onClick={dismiss} aria-label="Lembrar depois" data-testid="profile-reminder-dismiss"
        className="p-2 min-h-[40px] min-w-[40px] flex items-center justify-center text-purple-200 hover:text-white">
        <X className="h-4 w-4" />
      </button>
    </div>
  );
};
